export default __webpack_public_path__ + "static/media/collisionEvent.4c95d88f.png";